import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import Api from '../../component/Api';
import { useNavigate, useParams } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

export default function CourseDisciplineAECMapping() {
  const [message, setMessage] = useState(false);
  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);
  const [semester, setSemester] = useState([]);
  const [coursemapping, setCoursemapping] = useState([]);
  const [course_component, setCourse_component] = useState([]);
  const [facultyname, setFacultyname] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(false);
  const { http } = Api();
  const [errors, setErrors] = useState({ cname: '', cfaculty: '', cdiscipline: '', ccurriculum: '', cinternal: '', cexternal: '', clevel: '', csemester: '' });
  const navigate = useNavigate();
  let { id } = useParams();
  const decodedID = atob(id);
  sessionStorage.setItem("id", decodedID);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const id1 = sessionStorage.getItem("id");
        console.log(id1);
        const response1 = await http.get(`/Admin/getfaculty`);
        const response2 = await http.get(`/Admin/getdiscipline`);
        const response3 = await http.get(`/Admin/getcoursemapping/${id1}`);
        setFacultyData(response1.data.data);
        setDisciplineData(response2.data.data);
        setCoursemapping(response3.data);
        setFacultyname(response3.data[0].faculty_name);

        console.log(response3);
        const response = await http.get(`Admin/getCourseMappingByFacDisSemComp/{faculty_id}/{discipline_id}/{semester_id}/{component_id}?{params}`, {
          params: {
            faculty_id: response3.data[0].faculty_id,
            discipline_id: response3.data[0].discipline_id,
            semester_id: response3.data[0].semester_id,
            course_curriculum_structure_component_id: response3.data[0].course_curriculum_structure_component_id
          }
        });

        const k = response.data.find(courseComponent => courseComponent.course_name === response3.data[0].course_name);
        setSelectedCourse(k.id);
        setCourse_component(response.data);
        // console.log(response1, response2, response3, response, response3.data[0].faculty_id, response3.data[0].discipline_id, response3.data[0].semester_id, response3.data[0].course_curriculum_structure_component_id);
      } catch (error) {
        setMessage("something went wrong");
        console.error('Error fetching Course Discipline AEC mapping data:', error);
      }
    };
    fetchData();
  }, []);

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }

  const isdisiplin = () => {
    const faculty_id = document.getElementById('faculty_id').value;
    const selectedFaculty = faculty.find(facultys => parseInt(facultys.id) === parseInt(faculty_id));
    setFacultyname(selectedFaculty.faculty_name);
  }

  const handleCourseComponentChange = (selectedOption) => {

    setSelectedCourse(selectedOption.value);
  }

  const cancelForm = () => {
    navigate("/admin/coursedisciplineAECmapping");
  };

  const validateForm = () => {

    const updatedErrors = {};
    let hasError = false;


    const faculty_id = document.getElementById('faculty_id').value;
    const discipline_id = document.getElementById('discipline_id').value;
    const semester_id = document.getElementById('semester_id').value;
    const coursecomponentstype = document.getElementById('coursecomponentstype').value;

    // console.log(faculty_id, discipline_id, semester_id, coursecomponentstype);

    if (faculty_id === "0") {
      updatedErrors.cfaculty = 'select  a faculty';
      hasError = true;
    }

    if (discipline_id === "0") {

      updatedErrors.cdiscipline = 'select a discipline';
      hasError = true;
    }
    if (semester_id === "0") {
      updatedErrors.csemester = 'select a semester';
      hasError = true;
    }


    if (coursecomponentstype == "") {

      updatedErrors.ccomponenttype = 'Select a Course Component Type';
      hasError = true;
    }

    if (selectedCourse === false) {

      updatedErrors.ccourse = 'select a course';
      hasError = true;
    }


    if (hasError) {
      setErrors(updatedErrors);
      return false;
      

    } else {
      setErrors({ cfaculty: '', cdiscipline: '', csemester: '', ccomponenttype: '', ccourse: '' });
      return true;

    }

  };

  // const callfunction = async() =>{
    
  // }
  
  const saveForm = () => {

    if (validateForm()) {



      const faculty_id = document.getElementById('faculty_id').value;
      const discipline_id = document.getElementById('discipline_id').value;
      const semester_id = document.getElementById('semester_id').value;
      const coursecomponentstype = document.getElementById('coursecomponentstype').value;
      const remarks = document.getElementById('remarks').value;
      const remarksValue = remarks ? remarks : "Null";
      const id1 = sessionStorage.getItem("id");
      
      console.log(faculty_id, discipline_id, semester_id, coursecomponentstype, remarks, selectedCourse)
      http.post(`Admin/updatecoursemapping/${id1}`, {


        faculty_id: faculty_id,
        discipline_id: discipline_id,
        semester_id: semester_id,
        course_curriculum_structure_component_id: coursecomponentstype,
        course_id: selectedCourse,
        remarks: remarksValue,
        status: "active"

      }).then(response => {
        console.log(response);
        if (response.data.status_code === "MSG2") {

          sessionStorage.setItem("message", "Edit Successfull");
          navigate("/coursedisciplineAECmapping");
          console.log(response);

        }
      })
        .catch(error => {
          console.error(error);
          if (error.response && error.response.data.status_code === "ERR2") {
            setMessage("Please fill all outcomes");
          } else if (error.response && error.response.data.status_code === "ERR1") {
            setMessage("Duplicate entry");
          }
          else {
            setMessage("Something Went Wrong");
          }
        });
    }

  };

  return (
    <>
      <ToastContainer />
      <Template>
        {course_component.length === 0 ? (
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center ">
                        <h5>Edit AEC Mapping </h5>
                      </div>
                    </div>
                    <div className="card-body">
                      {message && (
                        <div className="alert alert-danger mar2" role="alert">
                          <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                        </div>
                      )}
                      <div className="card-body pdg">
                        <div className="table-responsive">
                          <div className="card-body custom-input">
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-7">Faculty Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={isdisiplin} required>
                                      <option value={0}>Select Faculty</option>
                                      {faculty.map(facultys => (
                                        <option value={facultys.id} selected={coursemapping[0].faculty_id === facultys.id ? 'selected' : null}>{facultys.faculty_name}</option>
                                      ))}
                                    </select>
                                    {errors.cfaculty && <p className="text-danger">{errors.cfaculty}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-7">Discipline <span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select className="form-control form-select scrollable-bar-select" id="discipline_id" name="discipline_id"  required>
                                      <option value={0}>Select Discipline</option>
                                      {discipline.map(disciplines => (
                                        disciplines.faculty_name === facultyname && (
                                          <option value={disciplines.id} selected={coursemapping[0].discipline_id === disciplines.id ? 'selected' : null}>{disciplines.discipline_name}</option>
                                        )
                                      ))}
                                    </select>
                                    {errors.cdiscipline && <p className="text-danger">{errors.cdiscipline}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-7">Semester <span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select className="form-control form-select scrollable-bar-select" id="semester_id" name="semester_id" required>
                                      <option value={0}>Select Semester</option>
                                      <option key={1} value={1} selected={coursemapping[0].semester_id === 1 ? 'selected' : null}> Semester-1</option>
                                      <option key={2} value={2} selected={coursemapping[0].semester_id === 2 ? 'selected' : null}> Semester-2</option>
                                    </select>
                                    {errors.csemester && <p className="text-danger">{errors.csemester}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-7">Select Course Component Type <span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select className="form-control form-select scrollable-bar-select" id="coursecomponentstype" name="coursecomponentstype" required>
                                      <option value="">---Select---</option>
                                      <option value={1} selected={coursemapping[0].course_curriculum_structure_component_id === 1 ? 'selected' : null}>Ability Enhancement Courses - AEC1 English</option>
                                      <option value={2} selected={coursemapping[0].course_curriculum_structure_component_id === 12 ? 'selected' : null}>Ability Enhancement Courses - AEC2 Other Languages</option>
                                    </select>
                                    {errors.ccurriculum && <p className="text-danger">{errors.ccurriculum}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-7">Course</label>
                                  <div className="col-sm-5">
                                    <Select
                                      className="form-control"
                                      id="coursecomponent"
                                      name="coursecomponent"
                                      options={course_component.map(coursecomponents => ({
                                        value: coursecomponents.id,
                                        label: coursecomponents.course_name
                                      }))}
                                      defaultValue={course_component
                                        .filter(coursecomponents => coursecomponents.course_name === coursemapping[0].course_name)
                                        .map(selectedComponent => ({
                                          value: selectedComponent.id,
                                          label: selectedComponent.course_name // Assuming 'course_name' is what you want to display
                                        }))
                                      }
                                      required
                                      onChange={handleCourseComponentChange}
                                    />
                                    {errors.ccourse && <p className="text-danger">{errors.ccourse}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-7">Remarks</label>
                                  <div className="col-sm-5">
                                    <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" defaultValue={coursemapping[0].remarks} />
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 txt-aln">
                            <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                            <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}
